import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  inject
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FileStore } from 'src/app/store/file-store';

@Component({
    selector: 'que-view-file',
    imports: [CommonModule],
    templateUrl: './view-file.component.html',
    styleUrls: ['./view-file.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [FileStore]
})
export class ViewFileComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  readonly store = inject(FileStore);

  readonly vm$ = this.store.vm$;

  ngOnInit(): void {
    const guid = this.route.snapshot.paramMap.get('guid');

    if (!guid) {
      this.store.setError('מזהה קובץ חסר');
      return;
    }

    this.store.loadFileByGuid(guid);
  }

  ngOnDestroy(): void {
    this.store.destroy();
  }

}